//
// interface CompanyData {
//   __typename?: 'CompanyContractStatus' | undefined;
//   id: string;
//   name: string;
//   category: CompanyCategory[];
//   companyContractStatusEnum: CompanyContractStatusEnum;
// }
//
// // Thứ tự ưu tiên sắp xếp
// const contractStatusOrder = [
//   CompanyContractStatusEnum.NoContract,
//   CompanyContractStatusEnum.NotPayed,
//   CompanyContractStatusEnum.ExpireSoon,
//   CompanyContractStatusEnum.Ended,
//   CompanyContractStatusEnum.Active,
// ];

export default function ContractCompaniesList() {
  // const navigate = useNavigate();
  // const { auth } = useAuth();
  // const { t } = useTranslate();
  //
  // const { data, loading, error, refetch } = useCompaniesWithContractStatus(0, 50);
  //
  // const [companies, setCompanies] = useState<CompanyData[]>([]);
  //
  // useEffect(() => {
  //   if (data) {
  //     const sortedCompanies = [...data.companyContractStatus].sort(
  //       (a, b) =>
  //         contractStatusOrder.indexOf(a.companyContractStatusEnum) -
  //         contractStatusOrder.indexOf(b.companyContractStatusEnum)
  //     );
  //     setCompanies(sortedCompanies);
  //   }
  // }, [data]);
  //
  // const onCompanyClick = (id: string) => {
  //   navigate(`/contract-management/${id}/contracts`);
  // };
  //
  // const handleSearchBar = useCallback(
  //   (searchString: string) => {
  //     if (data) {
  //       const regex = new RegExp(searchString.trim(), 'i');
  //       setCompanies(
  //         data.companyContractStatus
  //           .filter((company) => regex.test(company.name))
  //           .sort(
  //             (a, b) =>
  //               contractStatusOrder.indexOf(a.companyContractStatusEnum) -
  //               contractStatusOrder.indexOf(b.companyContractStatusEnum)
  //           )
  //       );
  //     }
  //   },
  //   [data]
  // );
  //
  // const allowedRoles = ['ADMIN', 'SUPER_ADMIN', 'CONTRACT_MANAGER'];
  // if (!allowedRoles.some((role) => auth?.role.includes(role))) {
  //   return <>Permission denied</>;
  // }
  //
  // if (loading) {
  //   return <Loading />;
  // }
  //
  // if (error) {
  //   throw error;
  // }
  //
  // if (!data) {
  //   return <div>No companies found</div>;
  // }
  //
  // return (
  //   <ContentLayout>
  //     <FullPrimaryContent>
  //       <Card>
  //         <CardHeader title={t('company-contracts.header')}>
  //           <SecondaryButton
  //             onClick={() => {
  //               void refetch();
  //             }}
  //           >
  //             <ArrowPathIcon className="w-5 h-5" />
  //           </SecondaryButton>
  //         </CardHeader>
  //
  //         <CardTableContent>
  //           <HistorySearchBar onChange={handleSearchBar} />
  //
  //           <Table
  //             data={companies}
  //             build={(item) => {
  //               return (
  //                 <TableRow
  //                   onClick={() => {
  //                     onCompanyClick(item.id);
  //                   }}
  //                   key={item.id}
  //                 >
  //                   <TableRowColumn>{item.name}</TableRowColumn>
  //                   <TableRowColumn className="hidden sm:table-cell">
  //                     <div
  //                       onClick={() => {
  //                         onCompanyClick(item.id);
  //                       }}
  //                     >
  //                       {item.category.map((item) => (
  //                         <span key={item}>{t(`contract.company.header.category.${item}`)}</span>
  //                       ))}
  //                     </div>
  //                   </TableRowColumn>
  //                   <TableRowColumn>
  //                     <div
  //                       onClick={() => {
  //                         onCompanyClick(item.id);
  //                       }}
  //                     >
  //                       <CompanyContractStatusMessage companyContractStatus={item.companyContractStatusEnum} />
  //                     </div>
  //                   </TableRowColumn>
  //                 </TableRow>
  //               );
  //             }}
  //             loading={loading}
  //             error={error}
  //           >
  //             <TableHeaderColumn>{t('contract-table.header.company')}</TableHeaderColumn>
  //             <TableHeaderColumn className="hidden sm:table-cell">
  //               {t('contract-table.header.category')}
  //             </TableHeaderColumn>
  //             <TableHeaderColumn>{t('contract-table.header.status')}</TableHeaderColumn>
  //           </Table>
  //         </CardTableContent>
  //       </Card>
  //     </FullPrimaryContent>
  //   </ContentLayout>
  // );
  return <>Em tắt chức năng trên alpha do lỗi merge</>;
}
